import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { Anchor, ButtonSubmit, Form } from '@anytag/shared-atoms';
import { useAllAvailableCountryOptions } from '@anytag/shared-hooks';
import { CheckBoxField, SelectorField, TextField } from '@anytag/shared-molecules';
import { isThailandCountry } from '@anytag/shared-utils';
import { TikTokSignupFormValues, TikTokSignupFormKeys } from './types';

export const Template = () => {
  const { t } = useTranslation();
  const {
    getValues,
    formState: { isSubmitting }
  } = useFormContext<TikTokSignupFormValues>();
  const { allAvailableCountryOptions } = useAllAvailableCountryOptions();

  const values = getValues();
  const hasAllFieldFilled = Object.values(values).every((field) => !!field);

  return (
    <Form.Body className="p-0">
      <div className="mx-auto my-0 w-178 px-10 py-12">
        <Form.Fields itemsPerRow={2}>
          <TextField<TikTokSignupFormKeys>
            name="companyName"
            title={t('TextForm.Company Name')}
            placeholder={t<string>('Company Name')}
            required
          />
          <TextField<TikTokSignupFormKeys>
            name="companyUrl"
            title={t('TextForm.Company URL')}
            placeholder="https://anytag.tech"
            required
          />
        </Form.Fields>

        <Form.Fields itemsPerRow={2}>
          <TextField<TikTokSignupFormKeys>
            name="phoneNumber"
            placeholder="066020485707"
            title={t('TextForm.Phone Number')}
            required
          />
          <TextField<TikTokSignupFormKeys>
            name="name"
            title={t('TextForm.Name')}
            placeholder={t<string>('Name')}
            required
          />
        </Form.Fields>
        <Form.Fields itemsPerRow={2}>
          <TextField<TikTokSignupFormKeys>
            name="email"
            title={t('TextForm.Email')}
            placeholder="your@email.com"
            required
          />
          <SelectorField<TikTokSignupFormKeys>
            name="countryId"
            title={t('Selector.Country')}
            required
            // https://adasiaholdings.atlassian.net/wiki/spaces/NC/pages/3567255574/Onboarding+process+for+TikTok+collab+service#%E2%91%A0Add-information
            options={allAvailableCountryOptions.filter((country) => isThailandCountry(country.value))}
            disabled
          />
        </Form.Fields>

        <CheckBoxField<TikTokSignupFormKeys>
          name="acceptTerms"
          label={
            <Trans
              i18nKey="I agree to the Privacy Policy and Terms of Service"
              components={{
                a: <Anchor variant="blue" target="_blank" className="inline text-sm leading-[1.4em]" to="/privacy" />,
                a1: <Anchor variant="blue" target="_blank" className="inline text-sm leading-[1.4em]" to="/terms" />
              }}
            />
          }
          required
          className="mx-0 mt-3 mb-4 flex justify-center text-sm [&_.checkbox-label]:text-tertiary"
        />

        <ButtonSubmit
          variant="solid"
          loading={isSubmitting}
          disabled={!hasAllFieldFilled}
          title={t('Button.Create Account')}
          className="my-0 flex w-87 justify-self-center"
        />
      </div>
    </Form.Body>
  );
};
